import { render, staticRenderFns } from "./veStuAssocInfoEdit.vue?vue&type=template&id=6c3366a6&scoped=true"
import script from "./veStuAssocInfoEdit.vue?vue&type=script&lang=js"
export * from "./veStuAssocInfoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3366a6",
  null
  
)

export default component.exports